import { Badge } from './ui/badge';
import { Zap, Radio } from 'lucide-react';

interface LessonModeBadgeProps {
  mode: 'live' | 'student-paced';
  size?: 'sm' | 'md' | 'lg';
}

export function LessonModeBadge({ mode, size = 'md' }: LessonModeBadgeProps) {
  const sizeClasses = {
    sm: 'text-xs px-2 py-0.5',
    md: 'text-sm px-3 py-1',
    lg: 'text-base px-4 py-1.5',
  };

  const iconSizes = {
    sm: 'w-3 h-3',
    md: 'w-3.5 h-3.5',
    lg: 'w-4 h-4',
  };

  if (mode === 'live') {
    return (
      <Badge
        className={`bg-emerald-100 text-emerald-700 border-emerald-200 rounded-lg ${sizeClasses[size]}`}
        variant="outline"
      >
        <Zap className={`${iconSizes[size]} mr-1`} />
        LIVE
      </Badge>
    );
  }

  return (
    <Badge
      className={`bg-blue-100 text-blue-700 border-blue-200 rounded-lg ${sizeClasses[size]}`}
      variant="outline"
    >
      <Radio className={`${iconSizes[size]} mr-1`} />
      STUDENT-PACED
    </Badge>
  );
}
